import { pickBy } from "ramda";

export const objectFilter = (
  obj: Record<string, any>,
  predicate: (obj: any) => boolean,
): Record<string, any> => {
  return pickBy(predicate, obj);
};
